import React from "react";
import { useAuth } from "../contexts/AuthContext";
import Subscriptions from "../Pages/Subscriptions"; // Your upgrade plan page

const ProtectedRoute = ({
  children,
  authConfig,
  fallbackComponent = null,
  showAccessDenied = true,
}) => {
  const { isAuthenticated, isLoading, isAuthorized, canAccessModuleFeature } =
    useAuth();

  // If still loading authentication, show loading
  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  // If not authenticated, this should be handled by parent route protection
  if (!isAuthenticated) {
    return null;
  }

  // If no auth config provided, allow access (public route)
  if (!authConfig) {
    return children;
  }

  // Enhanced access check function
  const hasAccess = () => {
    // For features with upgrade fallback, check actual module feature access
    if (authConfig.fallback === "upgrade-plan" && authConfig.feature) {
      return canAccessModuleFeature(authConfig.feature);
    }

    // For other features, use the regular authorization check
    return isAuthorized(authConfig);
  };

  // Check access
  const userHasAccess = hasAccess();

  // If user has access, render the protected component
  if (userHasAccess) {
    return children;
  }

  // If access denied and fallback is upgrade plan, show subscriptions
  if (authConfig.fallback === "upgrade-plan") {
    return fallbackComponent || <Subscriptions />;
  }

  // Default access denied message
  if (showAccessDenied) {
    return (
      <div
        className="access-denied-container"
        style={{
          padding: "2rem",
          textAlign: "center",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          margin: "2rem",
        }}
      >
        <h3 style={{ color: "#dc3545", marginBottom: "1rem" }}>
          Access Denied
        </h3>
        <p style={{ color: "#6c757d" }}>
          {authConfig.description ||
            "You don't have permission to access this feature."}
        </p>
        {authConfig.roles && (
          <p
            style={{ color: "#6c757d", fontSize: "0.9em", marginTop: "0.5rem" }}
          >
            Required roles: {authConfig.roles.join(", ")}
          </p>
        )}
        {authConfig.feature && (
          <p
            style={{ color: "#6c757d", fontSize: "0.9em", marginTop: "0.5rem" }}
          >
            Required feature: {authConfig.feature}
          </p>
        )}
      </div>
    );
  }

  return null;
};

export default ProtectedRoute;
